import React, {useState} from "react";
import classes from "./whatsapp.module.css";
import tick from "../../../assets/tick.svg";
import MorningSvg from "../../../assets/morning_sun.svg";
import AfternoonSvg from "../../../assets/afternoon_sun.svg";
import EveningSvg from "../../../assets/evening_moon.svg";

const MorningTimings = [ "7", "8", "9", "10"];
const AfternoonTimings = ["12", "1", "2", "3"];
const EveningTimings = ["7", "8", "9", "10"];
const Step2 = ({errorMsgs, morningTimeSelected, afternoonTimeSelected, eveningTimeSelected, setMorningTimeSelected, setAfternoonTimeSelected, setEveningTimeSelected}) => {
  return (
    <div className={classes.step2}>
      <div className={classes.step2_section1}>
        <div className={classes.step2_section1_header}>Set reminder timing</div>

        <div className="text_center">{errorMsgs.find((err) => err.input === "reminder") && <div className={classes.errorMessage}>{errorMsgs.find((err) => err.input === "reminder").msg}</div>}</div>

        <div className={classes.timingsDiv}>
          <div className={classes.timingsHeader}>
            <div>
              <img src={MorningSvg} alt="Morning Sun" />
              &nbsp; Morning
            </div>
            {morningTimeSelected?.length && (
              <div className={classes.timingSelectBox}>
                <img src={tick} alt="Tick" />
              </div>
            )}
          </div>

          <div className={classes.timingsSelectionsDiv}>
            {MorningTimings.map((time) => {
              return (
                <div
                  onClick={() => {
                    if (morningTimeSelected === time) {
                      setMorningTimeSelected();
                    } else {
                      setMorningTimeSelected(time);
                    }
                  }}
                  className={`${classes.timeDiv} ${morningTimeSelected === time && classes.selectedTimeDiv}`}>
                  {time}am
                </div>
              );
            })}
          </div>
        </div>
        <hr className={classes.timingsDivider} />

        <div className={classes.timingsDiv}>
          <div className={classes.timingsHeader}>
            <div>
              <img src={AfternoonSvg} alt="Morning Sun" />
              &nbsp; Afternoon
            </div>
            {afternoonTimeSelected?.length && (
              <div className={classes.timingSelectBox}>
                <img src={tick} alt="Tick" />
              </div>
            )}
          </div>

          <div className={classes.timingsSelectionsDiv}>
            {AfternoonTimings.map((time) => {
              return (
                <div
                  onClick={() => {
                    if (afternoonTimeSelected === time) {
                      setAfternoonTimeSelected();
                    } else {
                      setAfternoonTimeSelected(time);
                    }
                  }}
                  className={`${classes.timeDiv} ${afternoonTimeSelected === time && classes.selectedTimeDiv}`}>
                  {time}pm
                </div>
              );
            })}
          </div>
        </div>

        <hr className={classes.timingsDivider} />

        <div className={classes.timingsDiv}>
          <div className={classes.timingsHeader}>
            <div>
              <img src={EveningSvg} alt="Evening Moon" />
              &nbsp; Evening
            </div>
            {eveningTimeSelected?.length && (
              <div className={classes.timingSelectBox}>
                <img src={tick} alt="Tick" />
              </div>
            )}
          </div>

          <div className={classes.timingsSelectionsDiv}>
            {EveningTimings.map((time) => {
              return (
                <div
                  onClick={() => {
                    if (eveningTimeSelected === time) {
                      setEveningTimeSelected();
                    } else {
                      setEveningTimeSelected(time);
                    }
                  }}
                  className={`${classes.timeDiv} ${eveningTimeSelected === time && classes.selectedTimeDiv}`}>
                  {time}pm
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2;
